import { render, staticRenderFns } from "./CampoEditarNumero.vue?vue&type=template&id=d8471170&scoped=true"
import script from "./CampoEditarNumero.vue?vue&type=script&lang=js"
export * from "./CampoEditarNumero.vue?vue&type=script&lang=js"
import style0 from "./CampoEditarNumero.vue?vue&type=style&index=0&id=d8471170&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8471170",
  null
  
)

export default component.exports